import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { ThemeModeProvider } from './state/ThemeMode'

/**
 * The router's basename follows Vite's base, so the app works wherever it is
 * mounted - /app/ today, / after the server-rendered pages are retired -
 * without any path being written twice.
 */
const basename = import.meta.env.BASE_URL.replace(/\/$/, '')

/*
 * A DATA router, because only one can block a navigation (useBlocker), and
 * leaving a form with unsaved edits has to be able to ask first. One catch-all
 * route renders the app, which goes on declaring its own <Routes> as before.
 */
const router = createBrowserRouter([{ path: '*', element: <App /> }], { basename })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeModeProvider>
      <RouterProvider router={router} />
    </ThemeModeProvider>
  </StrictMode>,
)
